export default class Time extends EventTarget {
    constructor(GAME) {
        super();

        this.GAME = GAME;

        this.start = Date.now();
        this.current = this.start;
        this.elapsed = 0;

        this.paused = false;
        this.pauseStart = 0; // When the pause started
        this.totalPausedTime = 0; // Total time spent paused

        this.tick = this.tick.bind(this);
        this.tick();
    }

    resetTime() {
        this.start = Date.now();
        this.current = this.start;
        this.elapsed = 0;
        this.totalPausedTime = 0; // Reset total paused time
        this.paused = false; // Ensure the timer is not paused
        this.pauseStart = 0; // Reset pause start time
    }

    tick() {
        this.ticker = window.requestAnimationFrame(this.tick);

        const current = Date.now();

        if (!this.paused) {
            this.delta = current - this.current;
            this.elapsed = current - this.start - this.totalPausedTime;
            this.current = current;

            if (this.delta > 60) this.delta = 60;

            const event = new CustomEvent('tick', {
                detail: {
                    current: this.current,
                    elapsed: this.elapsed,
                    delta: this.delta,
                },
            });

            this.dispatchEvent(event);
        }
    }

    pause() {
        if (!this.paused) {
            this.paused = true;
            this.pauseStart = Date.now(); // Record when the pause started
            this.GAME.controls.enabled = false;
        }
    }

    resume() {
        if (this.paused) {
            this.paused = false;
            const pauseDuration = Date.now() - this.pauseStart; // Calculate how long the pause lasted
            this.totalPausedTime += pauseDuration; // Add to total paused time
            this.pauseStart = 0; // Reset pause start time
            this.GAME.controls.enabled = true;
        }
    }

    toggle() {
        (!this.paused) ? this.pause() : this.resume();
    }
}